<app-action-button-with-embedded-spinner [actionObservable]="updateSystemEvents.bind(this)" [icon]="'replay'"
    [hint]="'Update Events'"></app-action-button-with-embedded-spinner>